export class ExportLongPeriodError extends Error {
  public constructor() {
    super()

    this.message = 'errors.exportLongPeriod'
  }
}
